const _ = require('lodash');

const SuggestedListService = function suggestedListService(restangular, $q, bootstrap) {
    this._suggestedlistRoute = restangular.one('suggestedlists');
    this.restangular = restangular;
    this.suggestedlists = [];
    this.listName = '';
    this.listId = undefined;
    this.selectedListProductsCount = 0;
    this._suggestedListsPromise = null;

    if (bootstrap.isBootstrapped(bootstrap.bootstrapped.SuggestedLists)) {
        this._suggestedListsPromise = $q
            .when(bootstrap.getBootstrappedData(bootstrap.bootstrapped.SuggestedLists))
            .then(this._setSuggestedLists.bind(this));
    }
};


SuggestedListService.prototype._setSuggestedLists = function (data) {
    this.suggestedlists = data.Response;
    return this.suggestedlists;
};

SuggestedListService.prototype.listSuggestedLists = function () {
    if (this._suggestedListsPromise) {
        return this._suggestedListsPromise;
    }

    this._suggestedListsPromise = this._suggestedlistRoute.get()
        .then(this._setSuggestedLists.bind(this));

    return this._suggestedListsPromise;
};

SuggestedListService.prototype.selectList = function (listProductsService, listName, listId) {
    const self = this;
    const selectedList = _.find(self.suggestedlists, { ID: parseInt(listId) });
    self.listName = listName || selectedList.Name;
    self.listId = listId;
    listProductsService.suggestedListClickedPreviously = true;
    self.selectedListProductsCount = selectedList.ProductsCount;
};

function createArgs(args) {
    return {
        pageNumber: args.pageNumber,
        pageSize: args.pageSize || 10,
        sortType: args.sortType
    };
}

SuggestedListService.prototype.getProductsForSelectedList = function (args) {
    return this.listId === null
        ? null
        : this.restangular
        .one('suggestedlists', this.listId)
        .doGET('products', createArgs(args))
        .then(function (response) {
            return {
                items: response.Items,
                totalRecordCount: response.TotalRecordCount
            };
        });
};

module.exports = SuggestedListService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/suggestedlist/suggestedlist-service.js
 **/